<script>
export default {
  name: "contactUsImage"
};
</script>

<template>
  <el-row style="padding: 0; background-color: #2D2D2D">
    <el-col :span="24">
      <div class="container-image">
        <img
          src="../../assets/account-img.png"
          style="object-fit: cover;width: 100%; height: 132px"
        />
        <span class="centered-text">Contact Us</span>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.container-image {
  position: relative;
  text-align: center;
  color: white;
}

.centered-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "DINosaur-a";
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/contact/contactUsImage.vue